module.exports = __webpack_public_path__ + "0549d6f4e0202b0f4f6dc7f548d430bf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-30.png
// module id = 2125
// module chunks = 0